module.exports = __webpack_public_path__ + "img/students-header-bg.28de5fe2.svg";